<div class="row" id="settings-digital-card">
  @if (hasLoadedCardSettings && !isLoadingCardSettings) {
    @if (!hasDigitalCard) {
      <section class="col-12">
        <div class="rounded-card flex flex-col items-center text-center gap-3">
          <h3>{{ 'SYSTEM_SETTINGS.DIGITAL_CARD.NO_DIGITAL_CARD_TITLE' | translate }}</h3>
          <p class="text-sm">{{ 'SYSTEM_SETTINGS.DIGITAL_CARD.NO_DIGITAL_CARD_DESCRIPTION' | translate }}</p>
          <button type="button" class="btn primary-btn" data-testid="create-digital-card-btn" [disabled]="isCreatingDigitalCard" (click)="createDigitalCard()">{{ 'SYSTEM_SETTINGS.DIGITAL_CARD.BTN_CREATE_DIGITAL_CARD' | translate }}</button>
        </div>
      </section>
    } @else {
      <section class="col-12 dc-preview-panel overflow-visible">
        <div class="flex flex-wrap items-center justify-between gap-3">
          <div>
            <h3>{{ 'SYSTEM_SETTINGS.DIGITAL_CARD.LIVE_PREVIEW' | translate }}</h3>
            <p class="text-sm mt-1">{{ 'SYSTEM_SETTINGS.DIGITAL_CARD.LIVE_PREVIEW_DESCRIPTION' | translate }}</p>
          </div>
        </div>
        <div #editorPreview class="dc-preview-canvas mt-4">
          <div class="dc-editor-stage" [style.width.px]="getEditorStageWidth()"
            [style.height.px]="getEditorStageHeight()">
            <div #editorCard class="dc-card dc-editor-card"
              [style.width.px]="getEditorCardWidth()"
              [style.height.px]="getEditorCardHeight()"
              [style.transform]="'scale(' + editorScale + ')'"
              [style.backgroundColor]="getBackgroundColor()"
              [style.borderRadius.px]="getCardBorderRadius()">
              @if (cardBackground) {
                <img class="dc-card-bg-image"
                  [src]="cardBackground" alt="" />
              }
              @for (key of textElementKeys; track trackByTextElementKey($index, key)) {
                @if (getTextElement(key).active) {
                  <div class="dc-card-element dc-text-element"
                    [style.left.%]="getTextElement(key).xPercent"
                    [style.top.%]="getTextElement(key).yPercent"
                    [style.color]="getTextElement(key).color"
                    [style.fontSize.px]="getTextElement(key).fontSize"
                    [style.textAlign]="getTextElement(key).textAlign"
                    (pointerdown)="startDrag($event, key)">
                    {{ getTextElementLabel(key) }}
                  </div>
                }
              }
              @if (cardConfig.elements.qrCode.active) {
                <div class="dc-card-element dc-qr-placeholder"
                  [style.left.%]="cardConfig.elements.qrCode.xPercent"
                  [style.top.%]="cardConfig.elements.qrCode.yPercent"
                  [style.width.px]="cardConfig.elements.qrCode.size"
                  [style.height.px]="cardConfig.elements.qrCode.size"
                  (pointerdown)="startDrag($event, 'qrCode')">
                  QR
                </div>
              }
            </div>
          </div>
        </div>
      </section>
      <section class="col-12 mt-4">
        <div class="dc-settings-grid">
          <div class="rounded-card overflow-visible dc-settings-card dc-card-properties-card">
            <h3>{{ 'SYSTEM_SETTINGS.DIGITAL_CARD.CARD_PROPERTIES' | translate }}</h3>
            <div class="row mt-3">
              <div class="field-wr flex flex-col col-12 col-md-6 col-lg-3 mb-0">
                <label class="dc-field-label block text-sm" for="card-width">{{ 'SYSTEM_SETTINGS.DIGITAL_CARD.WIDTH' | translate }}</label>
                <input id="card-width" type="number" min="1" [(ngModel)]="cardConfig.card.width" (ngModelChange)="onCardDimensionInputChange()" (blur)="onCardDimensionBlur('width')" />
              </div>
              <div class="field-wr flex flex-col col-12 col-md-6 col-lg-3 mb-0">
                <label class="dc-field-label block text-sm" for="card-height">{{ 'SYSTEM_SETTINGS.DIGITAL_CARD.HEIGHT' | translate }}</label>
                <input id="card-height" type="number" min="1" [(ngModel)]="cardConfig.card.height" (ngModelChange)="onCardDimensionInputChange()" (blur)="onCardDimensionBlur('height')" />
              </div>
              <div class="field-wr flex flex-col col-12 col-md-6 col-lg-3 mb-0">
                <label class="dc-field-label block text-sm" for="card-border-radius">{{ 'SYSTEM_SETTINGS.DIGITAL_CARD.RADIUS' | translate }}</label>
                <input id="card-border-radius" type="number" min="0" [(ngModel)]="cardConfig.card.borderRadius" (ngModelChange)="onCardDimensionInputChange()" (blur)="onCardDimensionBlur('borderRadius')" />
              </div>
              <div class="field-wr flex flex-col col-12 col-md-6 col-lg-3 mb-0">
                <label data-testid="digital-card-background-color-label" class="dc-field-label block text-sm">{{ 'SYSTEM_SETTINGS.DIGITAL_CARD.BG_COLOR' | translate }}</label>
                <div class="color-picker-wr" [class.cp-undefined-color]="!getBackgroundColor()">
                  <label class="cp-color-field">
                    <span class="cp-color-swatch" [style.background]="getBackgroundColor()"></span>
                    <input type="color" class="cp-color-input" [value]="getBackgroundColor()" (input)="onBackgroundNativeColorChange($event)" />
                  </label>
                  <input type="text" [ngModel]="getBackgroundColor()" (ngModelChange)="onBackgroundHexInput($event)" (blur)="onBackgroundHexBlur()" class="hex-input cp-hex-input" data-testid="digital-card-background-color-input" />
                </div>
              </div>
              <div class="field-wr flex flex-col col-12 col-md-6 col-lg-12 mb-0" id="card-bg-wr">
                <label class="dc-field-label block text-sm mb-3" for="digital-card-bg-upload">{{ 'SYSTEM_SETTINGS.DIGITAL_CARD.BG_IMAGE' | translate }}</label>
                @if (!cardBackground) {
                  <p-fileUpload data-testid="upload-digital-card-background-file-input" name="digitalBackgroundFile" accept=".png"
                    maxFileSize="10485760"
                    chooseLabel="{{ 'SYSTEM_SETTINGS.DIGITAL_CARD.BTN_ATTACH_DIGITAL_CARD_BACKGROUND_FILE' | translate }}"
                    (onSelect)="onBackgroundImageUpload($event)" [customUpload]="true" [showUploadButton]="false"
                    [showCancelButton]="false">
                    <ng-template pTemplate="empty">
                      <div class="flex align-items-center justify-content-center flex-column">
                        <i class="pi pi-cloud-upload border-2"></i>
                        <p class="mt-2 mb-1">{{ 'SYSTEM_SETTINGS.DIGITAL_CARD.ATTACH_FILES_BY_DRAG_AND_DROP' | translate }}</p>
                      </div>
                    </ng-template>
                  </p-fileUpload>
                  <div class="error-hint-wr">
                    @if (fileUploadError) {
                      <small class="p-error">{{ fileUploadError }}</small>
                    }
                  </div>
                } @else {
                  <button type="button" class="btn outline-btn mt-3" (click)="removeBackgroundImage()">
                    {{ 'SYSTEM_SETTINGS.DIGITAL_CARD.REMOVE_IMAGE' | translate }}
                  </button>
                }
              </div>
            </div>
          </div>
          @for (key of textElementKeys; track trackByTextElementKey($index, key)) {
            <div class="rounded-card overflow-visible dc-settings-card">
              <div class="flex items-center justify-between gap-3 mb-3">
                <h3>{{ getTextElementLabel(key) }}</h3>
                <div class="flex flex-row items-center gap-2">
                  <p-checkbox [inputId]="'digital-card-text-active-' + key" [name]="'digital-card-text-active-' + key" [binary]="true" [ngModel]="isTextElementActive(key)" (ngModelChange)="setTextElementActive(key, $event)" />
                  <label [for]="'digital-card-text-active-' + key">{{ 'SYSTEM_SETTINGS.DIGITAL_CARD.SHOW' | translate }}</label>
                </div>
              </div>
              <div class="row items-end">
                <div class="field-wr flex flex-col col-12 mb-3">
                  <label [attr.data-testid]="'digital-card-' + key + '-color-label'" class="block text-sm">{{ 'SYSTEM_SETTINGS.DIGITAL_CARD.TEXT_COLOR' | translate }}</label>
                  <div class="color-picker-wr" [class.cp-undefined-color]="!getTextColor(key)">
                    <label class="cp-color-field">
                      <span class="cp-color-swatch" [style.background]="getTextColor(key)"></span>
                      <input type="color" class="cp-color-input" [value]="getTextColor(key)" (input)="onTextNativeColorChange(key, $event)" />
                    </label>
                    <input type="text" [ngModel]="getTextColor(key)" (ngModelChange)="onTextHexInput(key, $event)" (blur)="onTextHexBlur(key)" class="hex-input cp-hex-input" [attr.data-testid]="'digital-card-' + key + '-color-input'" />
                  </div>
                </div>
                <div class="field-wr flex flex-col col-12 col-md-12 col-lg-6 mb-0">
                  <label class="dc-field-label">{{ 'SYSTEM_SETTINGS.DIGITAL_CARD.FONT_SIZE' | translate }}</label>
                  <input type="number" min="8" [ngModel]="getTextElement(key).fontSize" (ngModelChange)="setTextElementFontSize(key, $event)" />
                </div>
                <div class="field-wr flex flex-col col-12 col-md-12 col-lg-6 mb-0">
                  <label class="dc-field-label">{{ 'SYSTEM_SETTINGS.DIGITAL_CARD.ALIGNMENT' | translate }}</label>
                  <app-custom-dropdown
                    [options]="textAlignDropdownOptions"
                    optionLabel="text"
                    optionValue="id"
                    [isMultiselect]="false"
                    [showSelectionChips]="true"
                    [showSearchbox]="false"
                    [showClear]="false"
                    [compactUi]="false"
                    searchMode="local"
                    placeholder="Alignment"
                    [ngModel]="getTextAlignDropdownValue(key)"
                    (ngModelChange)="setTextAlignFromDropdown(key, $event)"
                    [attr.data-testid]="'digital-card-align-' + key">
                  </app-custom-dropdown>
                </div>
              </div>
            </div>
          }
          <div class="rounded-card overflow-visible dc-settings-card">
            <div class="flex items-center justify-between gap-3 mb-3">
              <h3>{{ 'SYSTEM_SETTINGS.DIGITAL_CARD.QR_CODE' | translate }}</h3>
              <div class="flex flex-row items-center gap-2">
                <p-checkbox inputId="digital-card-qr-active" name="digital-card-qr-active" [binary]="true" [(ngModel)]="cardConfig.elements.qrCode.active" />
                <label for="digital-card-qr-active">{{ 'SYSTEM_SETTINGS.DIGITAL_CARD.SHOW' | translate }}</label>
              </div>
            </div>
            <div class="field-wr mb-0">
              <label class="dc-field-label" for="qr-size">{{ 'SYSTEM_SETTINGS.DIGITAL_CARD.SIZE' | translate }}</label>
              <input id="qr-size" type="number" min="40" [(ngModel)]="cardConfig.elements.qrCode.size" />
            </div>
            <div class="field-wr mb-0">
              <label class="dc-field-label" for="qr-content">Content</label>
              <input id="qr-content" type="text" [(ngModel)]="qrContent" />
            </div>
          </div>
        </div>
      </section>
      <hr class="w-full mb-6 mt-6 border-t">
      <div class="col-12 mt-1 mb-3">
        <div class="flex items-center justify-end gap-3">
          <button type="button" class="btn outline-btn" (click)="clearSettings()">{{ 'SYSTEM_SETTINGS.DIGITAL_CARD.RESET_SETTINGS' | translate }}</button>
          <button type="button" class="btn primary-btn" (click)="saveSettings()">{{ 'SYSTEM_SETTINGS.DIGITAL_CARD.UPDATE_SETTINGS' | translate }}</button>
          <button type="button" class="btn red-btn" (click)="displayDeleteDigitalCardModalbox()">{{ 'SYSTEM_SETTINGS.DIGITAL_CARD.DELETE_SETTINGS' | translate }}</button>
        </div>
      </div>
    }
  }
</div>

<!-- Modalbox: delete Digital Card -->
<p-dialog [(visible)]="showDeleteDigitalCardModalbox" [modal]="true" [draggable]="false" [resizable]="false" [header]="'SYSTEM_SETTINGS.DIGITAL_CARD.MODALBOX_TITLE_DELETE' | translate" [closable]="true" appendTo="body" class="digital-card-delete-dialog">
  <div class="row">
    <div class="col-12">
      <p class="pb-3">{{ 'SYSTEM_SETTINGS.DIGITAL_CARD.MODALBOX_DELETE_INFO' | translate }}</p>
    </div>
  </div>
  <ng-template #footer>
    <button
      type="button"
      class="btn outline-btn"
      (click)="cancelDeleteDigitalCard()">
      {{ 'SYSTEM_SETTINGS.DIGITAL_CARD.BTN_CANCEL' | translate }}
    </button>

    <button
      type="button"
      class="btn primary-btn"
      [disabled]="isDeletingDigitalCard"
      (click)="deleteSettings()">
      {{ 'SYSTEM_SETTINGS.DIGITAL_CARD.BTN_CONFIRM_DELETE' | translate }}
    </button>
  </ng-template>
</p-dialog>
